// Single source of truth for the dashboard period selector.
// Imported by BtFilters.vue (live) and DropdownPeriod.vue (legacy).
export const CUSTOM_PERIOD = "Custom";

export const PERIODS = [
  "Today",
  "Last 7 Days",
  "Last 14 Days",
  "Last 30 Days",
  "Last 90 Days",
  "Last 365 Days",
  "All Time",
  CUSTOM_PERIOD,
];
